import { createRoute } from '@tanstack/react-router';
import type { EzyModule } from '../module';
import { BookingList } from './BookingList';
import { BOOKING_REQUESTS } from './fixtures';

const booking: EzyModule = {
  // Chưa khai `nav`: thêm nhóm menu làm hỏng zone.test.ts (ngoài phạm vi luồng D) — xem "Cần anh quyết" ở PR D-04a.
  routes: (parent) => [createRoute({ getParentRoute: () => parent, path: '/booking', component: BookingList })],
  fixtures: (register) => register('booking', BOOKING_REQUESTS),
};
export default booking;
